(function() {

  function trackClarityEvent(eventName) {
    if (typeof window.clarity === 'function') {
      window.clarity('event', eventName);
    }
  }

  function initUGC() {

    const section = document.querySelector('#darkegg-ugc-section');
    if (!section) return;

    const track         = section.querySelector('[data-ugc-track]');
    const cards         = section.querySelectorAll('.darkegg-ugc__card');
    const prev          = section.querySelector('.darkegg-ugc__arrow--prev');
    const next          = section.querySelector('.darkegg-ugc__arrow--next');
    const dotsContainer = section.querySelector('[data-ugc-dots]');

    if (!track || !cards.length) return;

    function scrollBehavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto' : 'smooth';
    }

    /* CREATE DOTS */
    if (dotsContainer && cards.length > 1) {
      cards.forEach(function(card, index) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'darkegg-ugc__dot';
        dot.setAttribute('aria-label', 'Vai al video ' + (index + 1));

        dot.addEventListener('click', function() {
          card.scrollIntoView({
            behavior: scrollBehavior(),
            block: 'nearest',
            inline: 'start'
          });
        });

        dotsContainer.appendChild(dot);
      });
    }

    const dots = dotsContainer
      ? dotsContainer.querySelectorAll('.darkegg-ugc__dot')
      : [];

    /* INTERSECTION OBSERVER PER DOTS */
    if (dots.length) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const index = Array.from(cards).indexOf(entry.target);

            dots.forEach(function(dot, i) {
              dot.classList.toggle('active', i === index);
            });
          }
        });
      }, { root: track, threshold: 0.5 });

      cards.forEach(function(card) {
        observer.observe(card);
      });
    }

    /* ARROWS */
    function getScrollAmount() {
      return (cards[0] ? cards[0].offsetWidth : 300) + 20;
    }

    if (next) {
      next.addEventListener('click', function() {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: scrollBehavior()
        });
      });
    }

    if (prev) {
      prev.addEventListener('click', function() {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: scrollBehavior()
        });
      });
    }

    /* UGC VIDEO - TRACK PLAY */
    const videos = section.querySelectorAll('video');

    videos.forEach(function(video) {

      let tracked = false;

      video.addEventListener('play', function() {
        if (tracked) return;
        tracked = true;
        trackClarityEvent('ugc_video_play');
      });

    });

    /* INSTAGRAM CLICK */
    const instagramLinks = section.querySelectorAll('.darkegg-ugc__instagram');

    instagramLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        trackClarityEvent('ugc_instagram_click');
      });
    });

    /* CAROSELLO IMMAGINI INTERNO ALLE CARD */
    section.querySelectorAll('[data-ugc-carousel]').forEach(function(carousel) {

      const carouselTrack = carousel.querySelector('[data-ugc-carousel-track]');
      const carouselDots  = carousel.querySelectorAll('.darkegg-ugc__carousel-dot');
      const carouselPrev  = carousel.querySelector('.darkegg-ugc__carousel-arrow--prev');
      const carouselNext  = carousel.querySelector('.darkegg-ugc__carousel-arrow--next');

      const total = carouselDots.length;
      let current = 0;

      function goTo(index) {
        current = (index + total) % total;
        carouselTrack.style.transform = `translateX(-${current * 100}%)`;
        carouselDots.forEach(function(d, i) {
          d.classList.toggle('active', i === current);
        });
      }

      if (carouselPrev) {
        carouselPrev.addEventListener('click', function() { goTo(current - 1); });
      }

      if (carouselNext) {
        carouselNext.addEventListener('click', function() { goTo(current + 1); });
      }

    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUGC);
  } else {
    initUGC();
  }

})();
